webpackJsonp([1],Array(34).concat([
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(348),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(284)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Home = __webpack_require__(317);

var _Home2 = _interopRequireDefault(_Home);

var _Clients = __webpack_require__(313);

var _Clients2 = _interopRequireDefault(_Clients);

var _Client = __webpack_require__(309);

var _Client2 = _interopRequireDefault(_Client);

var _ClientList = __webpack_require__(311);

var _ClientList2 = _interopRequireDefault(_ClientList);

var _ClientView = __webpack_require__(312);

var _ClientView2 = _interopRequireDefault(_ClientView);

var _ClientForm = __webpack_require__(310);

var _ClientForm2 = _interopRequireDefault(_ClientForm);

var _Articles = __webpack_require__(305);

var _Articles2 = _interopRequireDefault(_Articles);

var _Article = __webpack_require__(301);

var _Article2 = _interopRequireDefault(_Article);

var _ArticleList = __webpack_require__(303);

var _ArticleList2 = _interopRequireDefault(_ArticleList);

var _ArticleView = __webpack_require__(304);

var _ArticleView2 = _interopRequireDefault(_ArticleView);

var _ArticleForm = __webpack_require__(302);

var _ArticleForm2 = _interopRequireDefault(_ArticleForm);

var _Cameras = __webpack_require__(308);

var _Cameras2 = _interopRequireDefault(_Cameras);

var _Camera = __webpack_require__(306);

var _Camera2 = _interopRequireDefault(_Camera);

var _CameraList = __webpack_require__(307);

var _CameraList2 = _interopRequireDefault(_CameraList);

var _Devices = __webpack_require__(316);

var _Devices2 = _interopRequireDefault(_Devices);

var _Device = __webpack_require__(314);

var _Device2 = _interopRequireDefault(_Device);

var _DeviceList = __webpack_require__(315);

var _DeviceList2 = _interopRequireDefault(_DeviceList);

var _ErrorPage = __webpack_require__(188);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = [{ path: '/', component: _Home2.default }, { path: '/clients',
  component: _Clients2.default,
  children: [{ path: '', component: _ClientList2.default }, { path: 'create', component: _ClientForm2.default, props: { update: false } }, {
    path: ':client_id(\\d+)',
    component: _Client2.default,
    children: [{ path: '', component: _ClientView2.default }, { path: 'edit', component: _ClientForm2.default, props: { update: true } }, { path: 'articles',
      component: _Articles2.default,
      children: [{ path: '', component: _ArticleList2.default }, { path: 'create', component: _ArticleForm2.default, props: { update: false } }, { path: ':article_id(\\d+)',
        component: _Article2.default,
        children: [{ path: '', component: _ArticleView2.default }, { path: 'edit', component: _ArticleForm2.default, props: { update: true } }]
      }]
    }, {
      path: 'devices',
      component: _Devices2.default,
      children: [{ path: '', component: _DeviceList2.default }, { path: ':device_id(\\d+)', component: _Device2.default }]
    }, {
      path: 'cameras',
      component: _Cameras2.default,
      children: [{ path: '', component: _CameraList2.default }, { path: ':camera_id(\\d+)', component: _Camera2.default }]
    }]
  }]
}, { path: '*', components: { fullscreen: _ErrorPage2.default } }];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(36);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(37);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(217);

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = __webpack_require__(216);

var _actions2 = _interopRequireDefault(_actions);

var _api = __webpack_require__(215);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  strict: "production" !== 'production',
  state: {
    authenticated: !!window.localStorage.getItem('fusion.' + 'access_token'),
    accessToken: window.localStorage.getItem('fusion.' + 'access_token'),
    refreshToken: window.localStorage.getItem('fusion.' + 'refresh_token'),
    expiresIn: window.localStorage.getItem('fusion.' + 'expires_in'),
    adminId: window.localStorage.getItem('fusion.' + 'admin_id'),
    isError: false,
    showErrorBubble: false,
    error: {},
    client: {},
    clients: [],
    clientsTotal: 0,
    permissions: [],
    permissionsTotal: 0,
    clientPermissions: [],
    clientPermissionsTotal: 0,
    devices: [],
    devicesTotal: 0,
    clientDevices: [],
    iosDevicesTotal: 0,
    androidDevicesTotal: 0,
    cameras: [],
    camerasTotal: 0,
    clientCameras: [],
    novatekCamerasTotal: 0,
    ambarellaCamerasTotal: 0,
    aitCamerasTotal: 0,
    otusCamerasTotal: 0,
    icatchCamerasTotal: 0,
    etronCamerasTotal: 0,
    clientDevicesTotal: 0,
    clientDevicesByPeriods: [],
    clientCamerasTotal: 0,
    clientCamerasByPeriods: [],
    article: {},
    clientArticles: [],
    clientArticlesTotal: 0,
    deleteArticle: {},
    file: {}
  },
  mutations: _mutations2.default,
  actions: (0, _actions2.default)(_api2.default)
});

store.dispatch('setToken', store.state.accessToken);

exports.default = store;

/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(36);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(37);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueRouter = __webpack_require__(195);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _veeValidate = __webpack_require__(193);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _App = __webpack_require__(194);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(189);

var _routes2 = _interopRequireDefault(_routes);

var _index = __webpack_require__(190);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(191);

__webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_veeValidate2.default, {
  errorBagName: 'veeErrors',
  fieldsBagName: 'veeFields'
});
_vue2.default.use(window.VueCharts);

var router = new _vueRouter2.default({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: _routes2.default,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

_vue2.default.filter('numberDisplay', function (value) {
  return value ? value.toLocaleString() : 0;
});

new _vue2.default({
  store: _index2.default,
  router: router,
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(196);

var _axios2 = _interopRequireDefault(_axios);

var _nprogress = __webpack_require__(297);

var _nprogress2 = _interopRequireDefault(_nprogress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authHeader = void 0;

exports.default = {
  addTokenToHeader: function addTokenToHeader(token) {
    authHeader = 'Bearer ' + token;
  },
  request: function request(method, url, params, data) {
    _nprogress2.default.start();

    return _axios2.default.request({
      method: method,
      url: url,
      params: params,
      data: data,
      responseType: 'json',
      headers: {
        Authorization: authHeader
      }
    }).then(function (response) {
      _nprogress2.default.done();

      return _promise2.default.resolve(response);
    }).catch(function (error) {
      _nprogress2.default.done();

      return _promise2.default.reject(error);
    });
  },
  get: function get(url, params) {
    return this.request('get', url, params);
  },
  post: function post(url, data) {
    return this.request('post', url, {}, data);
  },
  put: function put(url, data) {
    return this.request('put', url, {}, data);
  },
  delete: function _delete(url) {
    return this.request('delete', url);
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

exports.default = function (api) {
  return {
    setToken: function setToken(context, token) {
      return api.addTokenToHeader(token);
    },
    login: function login(context, params) {
      return api.post('https://staging.api.fusionnextinc.com/v3' + '/auth', params).then(function (response) {
        return context.commit('LOGIN', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    getClient: function getClient(context, _ref) {
      var clientId = _ref.clientId,
          params = _ref.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId, params).then(function (response) {
        return context.commit('GET_CLIENT', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClients: function getClients(context, _ref2) {
      var params = _ref2.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/clients', params).then(function (response) {
        return context.commit('GET_CLIENTS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getPermissions: function getPermissions(context, _ref3) {
      var params = _ref3.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/permissions', params).then(function (response) {
        return context.commit('GET_PERMISSIONS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    setPermissions: function setPermissions(context, _ref4) {
      var clientId = _ref4.clientId,
          params = _ref4.params;

      return api.put('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId + '/permissions', params).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    getClientPermissions: function getClientPermissions(context, _ref5) {
      var clientId = _ref5.clientId,
          params = _ref5.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId + '/permissions', params).then(function (response) {
        return context.commit('GET_CLIENT_PERMISSIONS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getDevices: function getDevices(context, params) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/devices', params).then(function (response) {
        return context.commit('GET_DEVICES', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClientDevices: function getClientDevices(context, _ref6) {
      var clientId = _ref6.clientId,
          params = _ref6.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId + '/devices', params).then(function (response) {
        return context.commit('GET_CLIENT_DEVICES', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClientDevicesByPeriods: function getClientDevicesByPeriods(context, params) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/stats/devices/totals', params).then(function (response) {
        return context.commit('GET_CLIENT_DEVICES_BY_PERIODS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getAndroidDevicesTotal: function getAndroidDevicesTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/devices?platform=android&limit=1').then(function (response) {
        return context.commit('GET_ANDROID_DEVICES_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getIosDevicesTotal: function getIosDevicesTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/devices?platform=ios&limit=1').then(function (response) {
        return context.commit('GET_IOS_DEVICES_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getCameras: function getCameras(context, params) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras', params).then(function (response) {
        return context.commit('GET_CAMERAS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClientCameras: function getClientCameras(context, _ref7) {
      var clientId = _ref7.clientId,
          params = _ref7.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId + '/cameras', params).then(function (response) {
        return context.commit('GET_CLIENT_CAMERAS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClientCamerasByPeriods: function getClientCamerasByPeriods(context, params) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/stats/cameras/totals', params).then(function (response) {
        return context.commit('GET_CLIENT_CAMERAS_BY_PERIODS', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getNovatekCamerasTotal: function getNovatekCamerasTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras?platform=novatek&limit=1').then(function (response) {
        return context.commit('GET_NOVATEK_CAMERAS_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getAmbarellaCamerasTotal: function getAmbarellaCamerasTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras?platform=ambarella&limit=1').then(function (response) {
        return context.commit('GET_AMBARELLA_CAMERAS_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getAitCamerasTotal: function getAitCamerasTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras?platform=ait&limit=1').then(function (response) {
        return context.commit('GET_AIT_CAMERAS_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getOtusCamerasTotal: function getOtusCamerasTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras?platform=otus&limit=1').then(function (response) {
        return context.commit('GET_OTUS_CAMERAS_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getIcatchCamerasTotal: function getIcatchCamerasTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras?platform=icatch&limit=1').then(function (response) {
        return context.commit('GET_ICATCH_CAMERAS_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getEtronCamerasTotal: function getEtronCamerasTotal(context) {
      return api.get('https://staging.api.fusionnextinc.com/v3' + '/cameras?platform=etron&limit=1').then(function (response) {
        return context.commit('GET_ETRON_CAMERAS_TOTAL', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getArticle: function getArticle(context, _ref8) {
      var articleId = _ref8.articleId,
          params = _ref8.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/articles/' + articleId, params).then(function (response) {
        return context.commit('GET_ARTICLE', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClientArticles: function getClientArticles(context, _ref9) {
      var clientId = _ref9.clientId,
          params = _ref9.params;

      return api.get('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId + '/articles', params).then(function (response) {
        return context.commit('GET_CLIENT_ARTICLES', response);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    updateClient: function updateClient(context, _ref10) {
      var clientId = _ref10.clientId,
          params = _ref10.params;

      return api.put('https://staging.api.fusionnextinc.com/v3' + '/clients/' + clientId, params).then(function (response) {
        return context.commit('UPDATE_CLIENT', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    updateArticle: function updateArticle(context, _ref11) {
      var articleId = _ref11.articleId,
          params = _ref11.params;

      return api.put('https://staging.api.fusionnextinc.com/v3' + '/articles/' + articleId, params).then(function (response) {
        return context.commit('UPDATE_ARTICLE', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    createClient: function createClient(context, data) {
      return api.post('https://staging.api.fusionnextinc.com/v3' + '/clients', data).then(function (response) {
        return context.commit('CREATE_CLIENT', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    createArticle: function createArticle(context, data) {
      return api.post('https://staging.api.fusionnextinc.com/v3' + '/articles', data).then(function (response) {
        return context.commit('CREATE_ARTICLE', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    uploadFile: function uploadFile(context, data) {
      return api.post('https://staging.api.fusionnextinc.com/v3' + '/files', data).then(function (response) {
        return context.commit('UPLOAD_FILE', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    deleteArticle: function deleteArticle(context, articleId) {
      return api.delete('https://staging.api.fusionnextinc.com/v3' + '/articles/' + articleId).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    }
  };
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SET_ERROR: function SET_ERROR(state, error) {
    state.isError = true;
    state.error = error;
  },
  CLEAR_ERROR: function CLEAR_ERROR(state) {
    state.isError = false;
  },
  SHOW_ERROR_BUBBLE: function SHOW_ERROR_BUBBLE(state, value) {
    state.showErrorBubble = value;
  },
  LOGIN: function LOGIN(state, response) {
    state.accessToken = response.data.access_token;
    state.refreshToken = response.data.refresh_token;
    state.expiresIn = response.data.expires_in;
    state.adminId = response.data.admin_id;
  },
  LOGOUT: function LOGOUT(state) {
    state.accessToken = null;
    state.refreshToken = null;
    state.expiresIn = null;
    state.adminId = null;
  },
  SET_AUTHENTICATED: function SET_AUTHENTICATED(state, value) {
    state.authenticated = value;
  },
  GET_CLIENT: function GET_CLIENT(state, response) {
    state.client = response.data;
  },
  GET_CLIENTS: function GET_CLIENTS(state, response) {
    state.clients = response.data.items;
    state.clientsTotal = response.data.total;
  },
  GET_PERMISSIONS: function GET_PERMISSIONS(state, response) {
    state.permissions = response.data.items;
    state.permissionsTotal = response.data.total;
  },
  GET_CLIENT_PERMISSIONS: function GET_CLIENT_PERMISSIONS(state, response) {
    state.clientPermissions = response.data.items;
    state.clientPermissionsTotal = response.data.total;
  },
  GET_DEVICES: function GET_DEVICES(state, response) {
    state.devices = response.data.items;
    state.devicesTotal = response.data.total;
  },
  GET_ANDROID_DEVICES_TOTAL: function GET_ANDROID_DEVICES_TOTAL(state, response) {
    state.androidDevicesTotal = response.data.total;
  },
  GET_IOS_DEVICES_TOTAL: function GET_IOS_DEVICES_TOTAL(state, response) {
    state.iosDevicesTotal = response.data.total;
  },
  GET_CAMERAS: function GET_CAMERAS(state, response) {
    state.cameras = response.data.items;
    state.camerasTotal = response.data.total;
  },
  GET_NOVATEK_CAMERAS_TOTAL: function GET_NOVATEK_CAMERAS_TOTAL(state, response) {
    state.novatekCamerasTotal = response.data.total;
  },
  GET_AMBARELLA_CAMERAS_TOTAL: function GET_AMBARELLA_CAMERAS_TOTAL(state, response) {
    state.ambarellaCamerasTotal = response.data.total;
  },
  GET_AIT_CAMERAS_TOTAL: function GET_AIT_CAMERAS_TOTAL(state, response) {
    state.aitCamerasTotal = response.data.total;
  },
  GET_OTUS_CAMERAS_TOTAL: function GET_OTUS_CAMERAS_TOTAL(state, response) {
    state.otusCamerasTotal = response.data.total;
  },
  GET_ICATCH_CAMERAS_TOTAL: function GET_ICATCH_CAMERAS_TOTAL(state, response) {
    state.icatchCamerasTotal = response.data.total;
  },
  GET_ETRON_CAMERAS_TOTAL: function GET_ETRON_CAMERAS_TOTAL(state, response) {
    state.etronCamerasTotal = response.data.total;
  },
  GET_CLIENT_DEVICES: function GET_CLIENT_DEVICES(state, response) {
    state.clientDevices = response.data.items;
    state.clientDevicesTotal = response.data.total;
  },
  GET_CLIENT_DEVICES_BY_PERIODS: function GET_CLIENT_DEVICES_BY_PERIODS(state, response) {
    state.clientDevicesByPeriods = response.data.items;
  },
  GET_CLIENT_CAMERAS: function GET_CLIENT_CAMERAS(state, response) {
    state.clientCameras = response.data.items;
    state.clientCamerasTotal = response.data.total;
  },
  GET_CLIENT_CAMERAS_BY_PERIODS: function GET_CLIENT_CAMERAS_BY_PERIODS(state, response) {
    state.clientCamerasByPeriods = response.data.items;
  },
  GET_ARTICLE: function GET_ARTICLE(state, response) {
    state.article = response.data;
  },
  GET_CLIENT_ARTICLES: function GET_CLIENT_ARTICLES(state, response) {
    state.clientArticles = response.data.items;
    state.clientArticlesTotal = response.data.total;
  },
  UPDATE_CLIENT: function UPDATE_CLIENT(state, response) {
    state.client = response.data;
  },
  UPDATE_ARTICLE: function UPDATE_ARTICLE(state, response) {
    state.article = response.data;
  },
  CREATE_CLIENT: function CREATE_CLIENT(state, response) {
    state.client = response.data;
  },
  CREATE_ARTICLE: function CREATE_ARTICLE(state, response) {
    state.article = response.data;
  },
  UPLOAD_FILE: function UPLOAD_FILE(state, response) {
    state.file = response.data;
  }
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasicInput = __webpack_require__(33);

var _BasicInput2 = _interopRequireDefault(_BasicInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BasicInput2.default]
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasicInput = __webpack_require__(33);

var _BasicInput2 = _interopRequireDefault(_BasicInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BasicInput2.default],

  props: {
    alignment: String
  }
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(43);

var _assign2 = _interopRequireDefault(_assign);

var _BasicInput = __webpack_require__(33);

var _BasicInput2 = _interopRequireDefault(_BasicInput);

var _SingleInput = __webpack_require__(323);

var _SingleInput2 = _interopRequireDefault(_SingleInput);

var _WrapperInput = __webpack_require__(324);

var _WrapperInput2 = _interopRequireDefault(_WrapperInput);

var _flatpickr = __webpack_require__(293);

var _flatpickr2 = _interopRequireDefault(_flatpickr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BasicInput2.default],

  props: {
    alignment: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    SingleInput: _SingleInput2.default,
    WrapperInput: _WrapperInput2.default
  },

  data: function data() {
    return {
      datepicker: null,
      selectedDates: null
    };
  },
  mounted: function mounted() {
    if (!this.datepicker) {
      this.config.onValueUpdate = this.dateUpdated;
      this.datepicker = new _flatpickr2.default(this.$el, this.config);
      this.setDate(this.value);
    }
    this.$watch('config', this.redraw);
    this.$watch('value', this.setDate);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.datepicker && !this.static) {
      this.datepicker.destroy();
      this.datepicker = null;
    }
  },


  methods: {
    redraw: function redraw(newConfig) {
      this.datepicker.config = (0, _assign2.default)(this.datepicker.config, newConfig);
      this.datepicker.redraw();
      this.datepicker.jumpToDate();
    },
    setDate: function setDate(newDate, oldDate) {
      newDate && this.datepicker.setDate(newDate);
    },
    dateUpdated: function dateUpdated(selectedDates, dateStr) {
      this.date = dateStr;
    }
  },

  computed: {
    wrap: function wrap() {
      return !!this.config.wrap;
    },
    static: function _static() {
      return !!this.config.static;
    },
    name: function name() {
      return this.wrap ? 'wrapperInput' : 'singleInput';
    },

    date: {
      get: function get() {
        return this.selectedDates || this.value;
      },
      set: function set(newValue) {
        if (this.selectedDates !== newValue) {
          this.selectedDates = newValue;
          this.$emit('input', newValue);
        }
      }
    }
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(22);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    title: {
      type: String
    },
    okText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  },

  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(22);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(22);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paging = __webpack_require__(300);

var _paging2 = _interopRequireDefault(_paging);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vue-bulma-pagination',
  props: {
    urlPrefix: {
      type: String,
      default: '/'
    },
    urlBuilder: {
      type: Function,
      default: function _default(page) {
        return this.normalize(this.urlPrefix + '/' + page);
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    lastPage: Number,
    displayPage: {
      type: Number,
      default: 4
    },
    modifiers: {
      type: String,
      default: ''
    },
    prev: {
      type: String,
      default: 'Prev'
    },
    next: {
      type: String,
      default: 'Next'
    }
  },
  methods: {
    getNavClassName: function getNavClassName() {
      var optional = ['', 'is-centered', 'is-right'];
      if (['', 'is-centered', 'is-right'].indexOf(this.modifiers.trim()) >= 0) {
        return 'pagination ' + this.modifiers;
      } else {
        console.warn(" modifiers %s is not within the options ", this.modifiers, optional, '\n see more detail https://github.com/vue-bulma/vue-bulma-pagination#doc');
        return 'pagination';
      }
    },
    getPagingClassName: function getPagingClassName(item) {
      return this.currentPage !== item ? 'pagination-link' : 'pagination-link is-current';
    },
    outOfRegion: function outOfRegion(page) {
      return page < 1 || page > this.lastPage;
    },
    normalize: function normalize(path) {
      return path.replace(/\/+/g, '/');
    }
  },
  computed: {
    pagingList: function pagingList() {
      return (0, _paging2.default)(this.currentPage, this.lastPage, this.displayPage);
    },
    formatCurrentPage: function formatCurrentPage() {
      var currentPage = Number(this.currentPage);
      return currentPage > 0 ? currentPage : 1;
    },
    prevPage: function prevPage() {
      return Math.max(this.formatCurrentPage - 1, 1);
    },
    nextPage: function nextPage() {
      return Math.min(this.formatCurrentPage + 1, this.lastPage);
    }
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = __webpack_require__(321);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Sidebar = __webpack_require__(322);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _AppMain = __webpack_require__(319);

var _AppMain2 = _interopRequireDefault(_AppMain);

var _ErrorBubble = __webpack_require__(320);

var _ErrorBubble2 = _interopRequireDefault(_ErrorBubble);

var _ErrorPage = __webpack_require__(188);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _Login = __webpack_require__(318);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      hideSidebar: true,
      showErrorPage: false
    };
  },


  computed: {
    authenticated: function authenticated() {
      return this.$store.state.authenticated;
    }
  },

  components: {
    Navbar: _Navbar2.default,
    Sidebar: _Sidebar2.default,
    AppMain: _AppMain2.default,
    ErrorBubble: _ErrorBubble2.default,
    ErrorPage: _ErrorPage2.default,
    Login: _Login2.default
  },

  watch: {
    '$route.query': function $routeQuery() {
      this.hideSidebar = true;
    },
    '$store.state.isError': function $storeStateIsError(isError) {
      if (isError) {
        if (this.$store.state.error.message === 'Network Error') {
          this.$store.commit('SHOW_ERROR_BUBBLE', true);
        } else if (this.$store.state.error.response.status === 404) {
          this.showErrorPage = true;
        } else if (this.$store.state.error.response.status === 401 || this.$store.state.error.response.status === 403) {
          this.$store.commit('LOGOUT');
          this.$store.commit('SET_AUTHENTICATED', false);

          window.localStorage.clear();
        }
      }
      this.$store.commit('CLEAR_ERROR');
    }
  }
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        title: '',
        location: 'default',
        link: null,
        content: null,
        cover: ''
      },
      articleType: '',
      formData: null,
      filename: 'Choose a cover image ...',
      isLoading: false
    };
  },


  computed: {
    cancelUrl: function cancelUrl() {
      return this.update ? '/clients/' + this.$route.params.client_id + '/articles/' + this.$route.params.article_id : '/clients/' + this.$route.params.client_id + '/articles';
    }
  },

  methods: {
    onFileChange: function onFileChange(e) {
      this.formData = new window.FormData();
      this.formData.append('file1', e.target.files[0]);
      this.filename = e.target.files[0].name;
    },
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.uploadFile(_this.formData).then(function () {
          _this.fields.cover = _this.$store.state.file.file1.filename || _this.fields.cover;

          return _this.createOrUpdateArticle(_this.articleType, _this.$route.params.article_id, _this.$route.params.client_id, _this.fields);
        }).then(function () {
          _this.$router.push('/clients/' + _this.$route.params.client_id + '/articles/' + _this.$store.state.article.id);
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    },
    uploadFile: function uploadFile(data) {
      if (!data) {
        return new _promise2.default(function (resolve, reject) {
          resolve();
        });
      }

      return this.$store.dispatch('uploadFile', data);
    },
    createOrUpdateArticle: function createOrUpdateArticle(articleType, articleId, clientId, params) {
      if (articleType === 'content') {
        delete params.link;
      } else if (articleType === 'link') {
        delete params.content;
      }

      if (articleId) {
        return this.$store.dispatch('updateArticle', { articleId: articleId, params: params });
      }

      params.client_id = clientId;

      return this.$store.dispatch('createArticle', params);
    }
  },

  created: function created() {
    var _this2 = this;

    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });

    if (this.update) {
      this.$store.dispatch('getArticle', {
        articleId: this.$route.params.article_id
      }).then(function () {
        _this2.fields = {
          title: _this2.$store.state.article.title,
          location: _this2.$store.state.article.location,
          link: _this2.$store.state.article.link,
          content: _this2.$store.state.article.content,
          cover: _this2.$store.state.article.cover
        };

        _this2.articleType = _this2.$store.state.article.link ? 'link' : 'content';
      });
    }
  },


  props: ['update']
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(23);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.clientArticlesTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    }
  },

  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });

    this.$store.dispatch('getClientArticles', {
      clientId: this.$route.params.client_id,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getClientArticles', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      });
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBulmaModal = __webpack_require__(187);

exports.default = {
  data: function data() {
    return {
      apiUrl: 'https://staging.api.fusionnextinc.com/v3',
      showModal: false
    };
  },


  methods: {
    deleteItem: function deleteItem() {
      var _this = this;

      this.showModal = false;
      this.$store.dispatch('deleteArticle', this.$route.params.article_id).then(function () {
        _this.$router.push('/clients/' + _this.$route.params.client_id + '/articles');
      }).catch(function () {
        _this.$store.commit('SHOW_ERROR_BUBBLE', true);
      });
    },
    openDeleteArticleModal: function openDeleteArticleModal() {
      this.showModal = true;
    },
    closeDeleteArticleModal: function closeDeleteArticleModal() {
      this.showModal = false;
    }
  },

  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });

    this.$store.dispatch('getArticle', {
      articleId: this.$route.params.article_id
    });
  },


  components: {
    Modal: _vueBulmaModal.Modal
  }
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(23);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

var _vueBulmaDatepicker = __webpack_require__(34);

var _vueBulmaDatepicker2 = _interopRequireDefault(_vueBulmaDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      createdAfter: this.$route.query.created_after || '',
      createdBefore: this.$route.query.created_before || '',
      searchValue: this.$route.query.manufacturer || this.$route.query.model || this.$route.query.platform || this.$route.query.platform_ver || '',
      searchKey: this.$route.query.mac ? 'mac' : this.$route.query.manufacturer ? 'manufacturer' : this.$route.query.model ? 'model' : this.$route.query.platform ? 'platform' : this.$route.query.platform_ver ? 'platform_ver' : this.$route.query.firmware_ver ? 'firmware_ver' : 'mac',

      searchParams: {}
    };
  },


  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.clientCamerasTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    },
    searchCameras: function searchCameras() {
      var _this = this;

      this.searchParams[this.searchKey] = this.searchValue;
      this.searchParams.created_after = this.createdAfter;
      this.searchParams.created_before = this.createdBefore;

      (0, _keys2.default)(this.searchParams).filter(function (key) {
        return !_this.searchParams[key];
      }).forEach(function (key) {
        return delete _this.searchParams[key];
      });

      this.$router.push({
        path: '/clients/' + this.$route.params.client_id + '/cameras',
        query: this.searchParams
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });

    this.$store.dispatch('getClientCameras', {
      clientId: this.$route.params.client_id,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getClientCameras', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      });
    },
    searchKey: function searchKey(newSearchKey, oldSearchKey) {
      delete this.searchParams[oldSearchKey];
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default,
    Datepicker: _vueBulmaDatepicker2.default
  }
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

var _vueBulmaModal = __webpack_require__(187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        name: '',
        platform: '',
        package_name: ''
      },
      checkedPermissions: [],
      isLoading: false,
      showClientCredentialsModal: false
    };
  },


  computed: {
    cancelUrl: function cancelUrl() {
      return this.update ? '/clients/' + this.$route.params.client_id : '/clients';
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.createOrUpdateClient(_this.$route.params.client_id, _this.fields).then(function () {
          return _this.$store.dispatch('setPermissions', {
            clientId: _this.$store.state.client.id,
            params: { permission_id: _this.checkedPermissions.join(',') }
          });
        }).then(function () {
          if (_this.update) {
            _this.$router.push('/clients/' + _this.$route.params.client_id);
          } else {
            _this.showClientCredentialsModal = true;
          }
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    },
    createOrUpdateClient: function createOrUpdateClient(clientId, params) {
      if (clientId) {
        delete params.package_name;
        delete params.platform;
      }

      return clientId ? this.$store.dispatch('updateClient', { clientId: clientId, params: params }) : this.$store.dispatch('createClient', params);
    },
    hideClientCredentialsModal: function hideClientCredentialsModal() {
      this.showClientCredentialsModal = false;

      this.$nextTick(function () {
        this.$router.push('/clients/' + this.$store.state.client.id);
      });
    }
  },

  created: function created() {
    var _this2 = this;

    if (this.update) {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      }).then(function () {
        return _this2.$store.dispatch('getClientPermissions', {
          clientId: _this2.$route.params.client_id
        });
      }).then(function () {
        _this2.fields = {
          name: _this2.$store.state.client.name,
          platform: _this2.$store.state.client.platform,
          package_name: _this2.$store.state.client.package_name
        };

        _this2.checkedPermissions = _this2.$store.state.clientPermissions.map(function (item) {
          return item.id;
        });
      });
    }

    this.$store.dispatch('getPermissions', {});
  },


  components: {
    Modal: _vueBulmaModal.Modal
  },

  props: ['update']
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(23);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      searchValue: this.$route.query.name || this.$route.query.package_name || this.$route.query.platform || '',
      searchKey: this.$route.query.name ? 'name' : this.$route.query.package_name ? 'package_name' : this.$route.query.platform ? 'platform' : 'name',

      searchParams: {}
    };
  },


  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.clientsTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    },
    searchClients: function searchClients() {
      var _this = this;

      this.searchParams[this.searchKey] = this.searchValue;

      (0, _keys2.default)(this.searchParams).filter(function (key) {
        return !_this.searchParams[key];
      }).forEach(function (key) {
        return delete _this.searchParams[key];
      });

      this.$router.push({
        path: '/clients',
        query: this.searchParams
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getClients', {
      params: (0, _extends3.default)({}, this.$route.query, {
        include: 'devices_count,cameras_count,articles_count'
      })
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getClients', {
        params: (0, _extends3.default)({}, this.$route.query, {
          include: 'devices_count,cameras_count,articles_count'
        })
      });
    },
    searchKey: function searchKey(newSearchKey, oldSearchKey) {
      delete this.searchParams[oldSearchKey];
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(241);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

var _vueBulmaDatepicker = __webpack_require__(34);

var _vueBulmaDatepicker2 = _interopRequireDefault(_vueBulmaDatepicker);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      startDate: (0, _moment2.default)().subtract(1, 'months').format('YYYY-MM-DD'),
      endDate: (0, _moment2.default)().format('YYYY-MM-DD')
    };
  },


  computed: {
    daysTotal: function daysTotal() {
      return (0, _moment2.default)(this.endDate).diff((0, _moment2.default)(this.startDate), 'days');
    },
    devicesByPeriods: function devicesByPeriods() {
      var date = (0, _moment2.default)(this.startDate);
      var amounts = {};
      var result = {};

      this.$store.state.clientDevicesByPeriods.forEach(function (item) {
        amounts[item.period] = item.amount;
      });

      while (date <= (0, _moment2.default)(this.endDate)) {
        result[date.format('YYYY-MM-DD')] = amounts[date.format('YYYY-MM-DD')] || 0;

        date.add(1, 'days');
      }

      return result;
    },
    devicePeriods: function devicePeriods() {
      return (0, _keys2.default)(this.devicesByPeriods);
    },
    deviceAmounts: function deviceAmounts() {
      return (0, _values2.default)(this.devicesByPeriods);
    },
    camerasByPeriods: function camerasByPeriods() {
      var date = (0, _moment2.default)(this.startDate);
      var amounts = {};
      var result = {};

      this.$store.state.clientCamerasByPeriods.forEach(function (item) {
        amounts[item.period] = item.amount;
      });

      while (date <= (0, _moment2.default)(this.endDate)) {
        result[date.format('YYYY-MM-DD')] = amounts[date.format('YYYY-MM-DD')] || 0;

        date.add(1, 'days');
      }

      return result;
    },
    cameraPeriods: function cameraPeriods() {
      return (0, _keys2.default)(this.camerasByPeriods);
    },
    cameraAmounts: function cameraAmounts() {
      return (0, _values2.default)(this.camerasByPeriods);
    },
    devicesByPeriodsTotal: function devicesByPeriodsTotal() {
      return this.deviceAmounts.reduce(function (sum, current) {
        return sum + current;
      });
    },
    camerasByPeriodsTotal: function camerasByPeriodsTotal() {
      return this.cameraAmounts.reduce(function (sum, current) {
        return sum + current;
      });
    }
  },

  watch: {
    startDate: function startDate() {
      this.getDataForGraphs();
    },
    endDate: function endDate() {
      this.getDataForGraphs();
    }
  },

  methods: {
    getDataForGraphs: function getDataForGraphs() {
      this.$store.dispatch('getClientDevicesByPeriods', {
        client_id: this.$route.params.client_id,
        created_after: this.startDate,
        created_before: this.endDate + ' 23:59:59',
        limit: this.daysTotal
      });

      this.$store.dispatch('getClientCamerasByPeriods', {
        client_id: this.$route.params.client_id,
        created_after: this.startDate,
        created_before: this.endDate + ' 23:59:59',
        limit: this.daysTotal
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id,
      params: {
        include: 'devices_count,cameras_count,articles_count'
      }
    });

    this.getDataForGraphs();
  },


  components: {
    Datepicker: _vueBulmaDatepicker2.default
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(23);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

var _vueBulmaDatepicker = __webpack_require__(34);

var _vueBulmaDatepicker2 = _interopRequireDefault(_vueBulmaDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      createdAfter: this.$route.query.created_after || '',
      createdBefore: this.$route.query.created_before || '',
      searchValue: this.$route.query.manufacturer || this.$route.query.model || this.$route.query.platform || this.$route.query.platform_ver || '',
      searchKey: this.$route.query.manufacturer ? 'manufacturer' : this.$route.query.model ? 'model' : this.$route.query.platform ? 'platform' : this.$route.query.platform_ver ? 'platform_ver' : 'manufacturer',

      searchParams: {}
    };
  },


  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.clientDevicesTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    },
    searchDevices: function searchDevices() {
      var _this = this;

      this.searchParams[this.searchKey] = this.searchValue;
      this.searchParams.created_after = this.createdAfter;
      this.searchParams.created_before = this.createdBefore;

      (0, _keys2.default)(this.searchParams).filter(function (key) {
        return !_this.searchParams[key];
      }).forEach(function (key) {
        return delete _this.searchParams[key];
      });

      this.$router.push({
        path: '/clients/' + this.$route.params.client_id + '/devices',
        query: this.searchParams
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });

    this.$store.dispatch('getClientDevices', {
      clientId: this.$route.params.client_id,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getClientDevices', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      });
    },
    searchKey: function searchKey(newSearchKey, oldSearchKey) {
      delete this.searchParams[oldSearchKey];
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default,
    Datepicker: _vueBulmaDatepicker2.default
  }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      myoption: {},

      deviceLabels: ['Android', 'iOS'],
      deviceBackgroundColor: ['rgba(164, 198, 57, 0.7)', 'rgba(95, 201, 248, 0.7)'],
      deviceHoverBackgroundColor: ['rgba(164, 198, 57, 1)', 'rgba(95, 201, 248, 1)'],

      cameraLabels: ['Novatek', 'Ambarella', 'AIT', 'Otus', 'iCatch', 'Etron'],
      cameraBackgroundColor: ['rgba(255, 99, 132, 0.7)', 'rgba(54, 162, 235, 0.7)', 'rgba(255, 206, 86, 0.7)', 'rgba(75, 192, 192, 0.7)', 'rgba(153, 102, 255, 0.7)', 'rgba(255, 115, 04, 0.7)'],
      cameraHoverBackgroundColor: ['rgba(255,99,132,1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 115, 04, 1)']
    };
  },


  computed: {
    deviceData: function deviceData() {
      return [this.$store.state.androidDevicesTotal, this.$store.state.iosDevicesTotal];
    },
    cameraData: function cameraData() {
      return [this.$store.state.novatekCamerasTotal, this.$store.state.ambarellaCamerasTotal, this.$store.state.aitCamerasTotal, this.$store.state.otusCamerasTotal, this.$store.state.icatchCamerasTotal, this.$store.state.etronCamerasTotal];
    }
  },

  created: function created() {
    this.$store.dispatch('getClients', { limit: 1 });
    this.$store.dispatch('getDevices', { limit: 1 });
    this.$store.dispatch('getCameras', { limit: 1 });
    this.$store.dispatch('getAndroidDevicesTotal');
    this.$store.dispatch('getIosDevicesTotal');
    this.$store.dispatch('getNovatekCamerasTotal');
    this.$store.dispatch('getAmbarellaCamerasTotal');
    this.$store.dispatch('getAitCamerasTotal');
    this.$store.dispatch('getOtusCamerasTotal');
    this.$store.dispatch('getIcatchCamerasTotal');
    this.$store.dispatch('getEtronCamerasTotal');
  }
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      credentials: {
        grant_type: 'password',
        client_id: '4aDuV38A7602sgCETc53uYX5SiVYRz8g',
        username: '',
        password: '',
        user_type: 'admin'
      },
      error: '',
      year: new Date().getFullYear()
    };
  },


  methods: {
    login: function login(event) {
      var _this = this;

      if (event) event.preventDefault();

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.$store.dispatch('login', _this.credentials).then(function () {
          _this.$store.dispatch('setToken', _this.$store.state.accessToken);

          window.localStorage.setItem('fusion.' + 'access_token', _this.$store.state.accessToken);
          window.localStorage.setItem('fusion.' + 'refresh_token', _this.$store.state.refreshToken);
          window.localStorage.setItem('fusion.' + 'expires_in', _this.$store.state.expiresIn);
          window.localStorage.setItem('fusion.' + 'admin_id', _this.$store.state.adminId);

          window.localStorage.setItem('fusion.' + 'token_expiration_time', Math.round(Date.now() / 1000) + parseInt(_this.$store.state.expiresIn));
        }).then(function () {
          _this.$store.commit('SET_AUTHENTICATED', true);
        }).catch(function () {
          if (_this.$store.state.error.response) {
            _this.error = _this.$store.state.error.response.data.error_description;
            return;
          }

          _this.error = _this.$store.state.error.message;
          return;
        });
      });
    },
    clearError: function clearError() {
      this.$store.commit('CLEAR_ERROR');
      this.error = '';
    }
  }
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    show: function show() {
      return this.$store.state.showErrorBubble;
    }
  },

  methods: {
    hide: function hide(delay) {
      var _this = this;

      setTimeout(function () {
        if (_this.show) {
          _this.$store.commit('SHOW_ERROR_BUBBLE', false);
        }
      }, delay);
    }
  }
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['showBurger'],

  methods: {
    logout: function logout(event) {
      if (event) event.preventDefault();

      this.$store.commit('LOGOUT');
      this.$store.commit('SET_AUTHENTICATED', false);

      window.localStorage.clear();
    }
  }
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },


  methods: {
    logout: function logout(event) {
      if (event) event.preventDefault();

      this.$store.commit('LOGOUT');
      this.$store.commit('SET_AUTHENTICATED', false);

      window.localStorage.clear();
    }
  }
};

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 59,
	"./af.js": 59,
	"./ar": 66,
	"./ar-dz": 60,
	"./ar-dz.js": 60,
	"./ar-kw": 61,
	"./ar-kw.js": 61,
	"./ar-ly": 62,
	"./ar-ly.js": 62,
	"./ar-ma": 63,
	"./ar-ma.js": 63,
	"./ar-sa": 64,
	"./ar-sa.js": 64,
	"./ar-tn": 65,
	"./ar-tn.js": 65,
	"./ar.js": 66,
	"./az": 67,
	"./az.js": 67,
	"./be": 68,
	"./be.js": 68,
	"./bg": 69,
	"./bg.js": 69,
	"./bm": 70,
	"./bm.js": 70,
	"./bn": 71,
	"./bn.js": 71,
	"./bo": 72,
	"./bo.js": 72,
	"./br": 73,
	"./br.js": 73,
	"./bs": 74,
	"./bs.js": 74,
	"./ca": 75,
	"./ca.js": 75,
	"./cs": 76,
	"./cs.js": 76,
	"./cv": 77,
	"./cv.js": 77,
	"./cy": 78,
	"./cy.js": 78,
	"./da": 79,
	"./da.js": 79,
	"./de": 82,
	"./de-at": 80,
	"./de-at.js": 80,
	"./de-ch": 81,
	"./de-ch.js": 81,
	"./de.js": 82,
	"./dv": 83,
	"./dv.js": 83,
	"./el": 84,
	"./el.js": 84,
	"./en-SG": 85,
	"./en-SG.js": 85,
	"./en-au": 86,
	"./en-au.js": 86,
	"./en-ca": 87,
	"./en-ca.js": 87,
	"./en-gb": 88,
	"./en-gb.js": 88,
	"./en-ie": 89,
	"./en-ie.js": 89,
	"./en-il": 90,
	"./en-il.js": 90,
	"./en-nz": 91,
	"./en-nz.js": 91,
	"./eo": 92,
	"./eo.js": 92,
	"./es": 95,
	"./es-do": 93,
	"./es-do.js": 93,
	"./es-us": 94,
	"./es-us.js": 94,
	"./es.js": 95,
	"./et": 96,
	"./et.js": 96,
	"./eu": 97,
	"./eu.js": 97,
	"./fa": 98,
	"./fa.js": 98,
	"./fi": 99,
	"./fi.js": 99,
	"./fo": 100,
	"./fo.js": 100,
	"./fr": 103,
	"./fr-ca": 101,
	"./fr-ca.js": 101,
	"./fr-ch": 102,
	"./fr-ch.js": 102,
	"./fr.js": 103,
	"./fy": 104,
	"./fy.js": 104,
	"./ga": 105,
	"./ga.js": 105,
	"./gd": 106,
	"./gd.js": 106,
	"./gl": 107,
	"./gl.js": 107,
	"./gom-latn": 108,
	"./gom-latn.js": 108,
	"./gu": 109,
	"./gu.js": 109,
	"./he": 110,
	"./he.js": 110,
	"./hi": 111,
	"./hi.js": 111,
	"./hr": 112,
	"./hr.js": 112,
	"./hu": 113,
	"./hu.js": 113,
	"./hy-am": 114,
	"./hy-am.js": 114,
	"./id": 115,
	"./id.js": 115,
	"./is": 116,
	"./is.js": 116,
	"./it": 118,
	"./it-ch": 117,
	"./it-ch.js": 117,
	"./it.js": 118,
	"./ja": 119,
	"./ja.js": 119,
	"./jv": 120,
	"./jv.js": 120,
	"./ka": 121,
	"./ka.js": 121,
	"./kk": 122,
	"./kk.js": 122,
	"./km": 123,
	"./km.js": 123,
	"./kn": 124,
	"./kn.js": 124,
	"./ko": 125,
	"./ko.js": 125,
	"./ku": 126,
	"./ku.js": 126,
	"./ky": 127,
	"./ky.js": 127,
	"./lb": 128,
	"./lb.js": 128,
	"./lo": 129,
	"./lo.js": 129,
	"./lt": 130,
	"./lt.js": 130,
	"./lv": 131,
	"./lv.js": 131,
	"./me": 132,
	"./me.js": 132,
	"./mi": 133,
	"./mi.js": 133,
	"./mk": 134,
	"./mk.js": 134,
	"./ml": 135,
	"./ml.js": 135,
	"./mn": 136,
	"./mn.js": 136,
	"./mr": 137,
	"./mr.js": 137,
	"./ms": 139,
	"./ms-my": 138,
	"./ms-my.js": 138,
	"./ms.js": 139,
	"./mt": 140,
	"./mt.js": 140,
	"./my": 141,
	"./my.js": 141,
	"./nb": 142,
	"./nb.js": 142,
	"./ne": 143,
	"./ne.js": 143,
	"./nl": 145,
	"./nl-be": 144,
	"./nl-be.js": 144,
	"./nl.js": 145,
	"./nn": 146,
	"./nn.js": 146,
	"./pa-in": 147,
	"./pa-in.js": 147,
	"./pl": 148,
	"./pl.js": 148,
	"./pt": 150,
	"./pt-br": 149,
	"./pt-br.js": 149,
	"./pt.js": 150,
	"./ro": 151,
	"./ro.js": 151,
	"./ru": 152,
	"./ru.js": 152,
	"./sd": 153,
	"./sd.js": 153,
	"./se": 154,
	"./se.js": 154,
	"./si": 155,
	"./si.js": 155,
	"./sk": 156,
	"./sk.js": 156,
	"./sl": 157,
	"./sl.js": 157,
	"./sq": 158,
	"./sq.js": 158,
	"./sr": 160,
	"./sr-cyrl": 159,
	"./sr-cyrl.js": 159,
	"./sr.js": 160,
	"./ss": 161,
	"./ss.js": 161,
	"./sv": 162,
	"./sv.js": 162,
	"./sw": 163,
	"./sw.js": 163,
	"./ta": 164,
	"./ta.js": 164,
	"./te": 165,
	"./te.js": 165,
	"./tet": 166,
	"./tet.js": 166,
	"./tg": 167,
	"./tg.js": 167,
	"./th": 168,
	"./th.js": 168,
	"./tl-ph": 169,
	"./tl-ph.js": 169,
	"./tlh": 170,
	"./tlh.js": 170,
	"./tr": 171,
	"./tr.js": 171,
	"./tzl": 172,
	"./tzl.js": 172,
	"./tzm": 174,
	"./tzm-latn": 173,
	"./tzm-latn.js": 173,
	"./tzm.js": 174,
	"./ug-cn": 175,
	"./ug-cn.js": 175,
	"./uk": 176,
	"./uk.js": 176,
	"./ur": 177,
	"./ur.js": 177,
	"./uz": 179,
	"./uz-latn": 178,
	"./uz-latn.js": 178,
	"./uz.js": 179,
	"./vi": 180,
	"./vi.js": 180,
	"./x-pseudo": 181,
	"./x-pseudo.js": 181,
	"./yo": 182,
	"./yo.js": 182,
	"./zh-cn": 183,
	"./zh-cn.js": 183,
	"./zh-hk": 184,
	"./zh-hk.js": 184,
	"./zh-tw": 185,
	"./zh-tw.js": 185
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 296;

/***/ }),
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(331),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  "data-v-45f1ecf7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(356),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(290)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  "data-v-b232ed1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(336),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(344),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(332),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(292)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(283)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(330),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(286)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-addons flatpickr",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-input": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm._t("default")], 2)
  var _obj;
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles")
    }
  }, [_vm._v("Articles")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles/" + (this.$route.params.article_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.article.title))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new article")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.title),
      expression: "fields.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('title')
    },
    attrs: {
      "name": "title",
      "type": "text",
      "placeholder": "New article title",
      "data-vv-as": "Article title"
    },
    domProps: {
      "value": (_vm.fields.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('title')),
      expression: "veeErrors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('title')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('location')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.location),
      expression: "fields.location"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "location",
      "data-vv-as": "Location"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fields, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "slider"
    }
  }, [_vm._v("Slider")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('location')),
      expression: "veeErrors.has('location')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('location')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('articleType')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleType),
      expression: "articleType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|in:link,content'),
      expression: "'required|in:link,content'"
    }],
    attrs: {
      "name": "articleType",
      "data-vv-as": "Article type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.articleType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select article type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "content"
    }
  }, [_vm._v("Content")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('articleType')),
      expression: "veeErrors.has('articleType')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('articleType')))])]), _vm._v(" "), (_vm.articleType == 'link') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.link),
      expression: "fields.link"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|url'),
      expression: "'required|url'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('link')
    },
    attrs: {
      "name": "link",
      "type": "text",
      "placeholder": "URL",
      "data-vv-as": "Link"
    },
    domProps: {
      "value": (_vm.fields.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('link')),
      expression: "veeErrors.has('link')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('link')))])]) : _vm._e(), _vm._v(" "), (_vm.articleType == 'content') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Content")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.content),
      expression: "fields.content"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true, 'is-danger': _vm.veeErrors.has('content')
    },
    attrs: {
      "name": "content",
      "type": "text",
      "placeholder": "Some content here",
      "data-vv-as": "Content"
    },
    domProps: {
      "value": (_vm.fields.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('content')),
      expression: "veeErrors.has('content')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('content')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "file"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.fields.cover,
        image: true,
        ext: 'jpg'
      }),
      expression: "{ required: !fields.cover, image: true, ext: 'jpg' }"
    }],
    class: {
      'file-input': true, 'is-danger': _vm.veeErrors.has('file1')
    },
    attrs: {
      "name": "file1",
      "type": "file",
      "data-vv-as": "Cover file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file-cta"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v(_vm._s(_vm.filename))])])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Must be an image file with .jpg extension.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('file1')),
      expression: "veeErrors.has('file1')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('file1')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit article")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated nav-menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tachometer",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Applications")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-desktop"
  }, [_c('hr'), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0), _vm._v("Log out")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-bottom has-text-centered has-text-grey"
  }, [_c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("Fusion Next Inc. " + _vm._s(_vm.year) + " ©")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
}]}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-layer"
  }, [_c('div', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('span', {
    staticClass: "icon is-large has-text-white-ter"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-question-circle-o"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-white-ter"
  }, [_vm._v("Error 404")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-white-ter"
  }, [_vm._v("Resource not found!")])])])])])
}]}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles")
    }
  }, [_vm._v("Articles")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.article.title))])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal
    },
    on: {
      "close": _vm.closeDeleteArticleModal
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Deleting article")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Are you sure you want to "), _c('strong', [_vm._v("delete")]), _vm._v(" this article?")]), _vm._v(" "), _c('p', [_vm._v("This action cannot be undone.")])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.closeDeleteArticleModal
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.article.title))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Article ID:")]), _vm._v(" " + _vm._s(this.$store.state.article.id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Location:")]), _vm._v(" " + _vm._s(this.$store.state.article.location))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.article.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.article.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles/" + (this.$route.params.article_id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-danger is-outlined",
    on: {
      "click": _vm.openDeleteArticleModal
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Delete")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-1"
  }, [_c('article', {
    staticClass: "media"
  }, [(this.$store.state.article.cover) ? _c('figure', {
    staticClass: "media-left"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": (_vm.apiUrl + "/articles/covers/" + (this.$store.state.article.cover) + "?size=square")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [(this.$store.state.article.content) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.$store.state.article.content))])]) : _c('div', {
    staticClass: "content"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.$store.state.article.link))])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Cover:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Content:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Link:")])])
}]}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: _vm.getNavClassName()
  }, [_c('router-link', {
    staticClass: "pagination-previous",
    attrs: {
      "to": _vm.urlBuilder(_vm.prevPage),
      "disabled": _vm.outOfRegion(_vm.formatCurrentPage - 1)
    }
  }, [_vm._v(_vm._s(_vm.prev))]), _vm._v(" "), _c('router-link', {
    staticClass: "pagination-next",
    attrs: {
      "to": _vm.urlBuilder(_vm.nextPage),
      "disabled": _vm.outOfRegion(_vm.formatCurrentPage + 1)
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list"
  }, _vm._l((_vm.pagingList), function(item) {
    return _c('li', [(item !== '...') ? _c('router-link', {
      class: _vm.getPagingClassName(item),
      attrs: {
        "to": _vm.urlBuilder(item)
      }
    }, [_vm._v(_vm._s(item))]) : _c('span', {
      staticClass: "pagination-ellipsis"
    }, [_vm._v("...")])], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles/create")
    }
  }, [_vm._v("Create new article")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientArticlesTotal)))]), _vm._v(" articles")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.clientArticles.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No articles found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clientArticles), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/clients/" + (item.client_id) + "/articles/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('td', [(item.content) ? _c('span', {
      staticClass: "icon is-small tooltip",
      attrs: {
        "data-tooltip": "Text content"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })]) : _c('span', {
      staticClass: "icon is-small tooltip",
      attrs: {
        "data-tooltip": "Link"
      }
    }, [_c('i', {
      staticClass: "fa fa-link"
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Articles")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "in-out",
      "enter-active-class": "fadeInDown",
      "leave-active-class": "fadeOutUp",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.hide(5000)
      }
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "animated message-box"
  }, [_c('article', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(this.$store.state.error.name) + "!")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        _vm.hide(0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "message-body"
  }, [_vm._v("\n        " + _vm._s(this.$store.state.error.response ? this.$store.state.error.response.data.error.message : this.$store.state.error.message) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": '/clients/create'
    }
  }, [_vm._v("Create new application")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))]), _vm._v(" applications")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchClients($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("name")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "package_name"
    }
  }, [_vm._v("package")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform"
    }
  }, [_vm._v("platform")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchClients
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.clients.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No clients found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clients), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/clients/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.devices_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cameras_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Package name")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Devices")]), _vm._v(" "), _c('th', [_vm._v("Cameras")]), _vm._v(" "), _c('th', [_vm._v("Created at")])])])
}]}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.client.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Application ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.client_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Package name:")]), _vm._v(" " + _vm._s(this.$store.state.client.package_name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Platform:")]), _vm._v(" " + _vm._s(this.$store.state.client.platform))]), _c('p'), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.client.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.client.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Devices")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/devices")
    }
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.client.devices_count)))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Cameras")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/cameras")
    }
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.client.cameras_count)))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Articles")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/articles")
    }
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.client.articles_count)))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 is-offset-1"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _vm._m(1)], 1)])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Devices during this period")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(_vm.devicesByPeriodsTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Cameras during this period")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(_vm.camerasByPeriodsTotal)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('chartjs-bar', {
    attrs: {
      "datalabel": 'Devices by period',
      "backgroundcolor": 'rgba(255, 99, 132, 0.5)',
      "bordercolor": 'rgba(255,99,132,1)',
      "borderwidth": 1,
      "bind": true,
      "labels": _vm.devicePeriods,
      "data": _vm.deviceAmounts
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('chartjs-bar', {
    attrs: {
      "datalabel": 'Cameras by period',
      "backgroundcolor": 'rgba(255, 206, 86, 0.5)',
      "bordercolor": 'rgba(255, 206, 86, 1)',
      "borderwidth": 1,
      "bind": true,
      "labels": _vm.cameraPeriods,
      "data": _vm.cameraAmounts
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
}]}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "value": _vm.date,
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "alignment": _vm.alignment
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientDevicesTotal)))]), _vm._v(" devices")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.createdAfter),
      callback: function($$v) {
        _vm.createdAfter = $$v
      },
      expression: "createdAfter"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.createdBefore),
      callback: function($$v) {
        _vm.createdBefore = $$v
      },
      expression: "createdBefore"
    }
  }), _vm._v(" "), _vm._m(2)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchDevices($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "manufacturer"
    }
  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "model"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform"
    }
  }, [_vm._v("Platform")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform_ver"
    }
  }, [_vm._v("Platform version")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchDevices
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(!this.$store.state.clientDevices.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No devices found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clientDevices), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Devices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Platform version")]), _vm._v(" "), _c('th', [_vm._v("Created at")])])])
}]}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total applications")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total devices")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.devicesTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total cameras")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.camerasTotal)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5 is-offset-1"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v("Devices by platforms")]), _vm._v(" "), _c('chartjs-pie', {
    attrs: {
      "labels": _vm.deviceLabels,
      "data": _vm.deviceData,
      "backgroundcolor": _vm.deviceBackgroundColor,
      "hoverbackgroundcolor": _vm.deviceHoverBackgroundColor,
      "bind": true,
      "scalesdisplay": false,
      "option": _vm.myoption
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v("Cameras by platforms")]), _vm._v(" "), _c('chartjs-pie', {
    attrs: {
      "labels": _vm.cameraLabels,
      "data": _vm.cameraData,
      "backgroundcolor": _vm.cameraBackgroundColor,
      "hoverbackgroundcolor": _vm.cameraHoverBackgroundColor,
      "bind": true,
      "scalesdisplay": false,
      "option": _vm.myoption
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientCamerasTotal)))]), _vm._v(" cameras")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.createdAfter),
      callback: function($$v) {
        _vm.createdAfter = $$v
      },
      expression: "createdAfter"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.createdBefore),
      callback: function($$v) {
        _vm.createdBefore = $$v
      },
      expression: "createdBefore"
    }
  }), _vm._v(" "), _vm._m(2)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchCameras($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "mac"
    }
  }, [_vm._v("MAC address")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manufacturer"
    }
  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "model"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform"
    }
  }, [_vm._v("Platform")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform_ver"
    }
  }, [_vm._v("Platform version")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "firmware_ver"
    }
  }, [_vm._v("Firmware version")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchCameras
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(!this.$store.state.clientCameras.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No devices found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clientCameras), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mac))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.firmware_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Cameras")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("MAC")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Platform version")]), _vm._v(" "), _c('th', [_vm._v("Firmware version")]), _vm._v(" "), _c('th', [_vm._v("Created at")])])])
}]}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new application")])])], 2)]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showClientCredentialsModal
    },
    on: {
      "close": _vm.hideClientCredentialsModal
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Notice")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-warning"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Please, copy the "), _c('strong', [_vm._v("identifier")]), _vm._v(" below and store it in a safe place. This will not be shown again.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Identifier:")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.$store.state.client.identifier))])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.hideClientCredentialsModal
    }
  }, [_vm._v("OK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Application name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Client name",
      "data-vv-as": "Client name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('platform')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.platform),
      expression: "fields.platform"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "platform",
      "disabled": _vm.update,
      "data-vv-as": "Platform"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fields, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select one option")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "android"
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ios"
    }
  }, [_vm._v("iOS")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('platform')),
      expression: "veeErrors.has('platform')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('platform')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Package name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.package_name),
      expression: "fields.package_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^[A-Za-z0-9-_.]+$'),
      expression: "'required|regex:^[A-Za-z0-9-_.]+$'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('package_name')
    },
    attrs: {
      "name": "package_name",
      "type": "text",
      "placeholder": "Package name",
      "disabled": _vm.update,
      "data-vv-as": "Package name"
    },
    domProps: {
      "value": (_vm.fields.package_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "package_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('package_name')),
      expression: "veeErrors.has('package_name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('package_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Permissions")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, _vm._l((this.$store.state.permissions), function(permission) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedPermissions),
        expression: "checkedPermissions"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("field_" + (permission.name))
      },
      domProps: {
        "value": permission.id,
        "checked": Array.isArray(_vm.checkedPermissions) ? _vm._i(_vm.checkedPermissions, permission.id) > -1 : (_vm.checkedPermissions)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedPermissions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = permission.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedPermissions = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedPermissions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedPermissions = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("field_" + (permission.name))
      }
    }, [_vm._v(_vm._s(permission.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit application name")])])
}]}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.authenticated) ? _c('div', [_c('router-view', {
    attrs: {
      "name": "fullscreen"
    }
  }), _vm._v(" "), (_vm.showErrorPage) ? _c('error-page') : _vm._e(), _vm._v(" "), _c('error-bubble'), _vm._v(" "), _c('navbar', {
    attrs: {
      "showBurger": _vm.hideSidebar
    },
    on: {
      "toggleSidebar": function($event) {
        _vm.hideSidebar = !_vm.hideSidebar
      }
    }
  }), _vm._v(" "), _c('sidebar', {
    class: {
      'is-hidden-touch': _vm.hideSidebar
    }
  }), _vm._v(" "), _c('app-main')], 1) : _c('div', [_c('login')], 1)])
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.deactive
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    class: {
      'navbar-burger': true, 'burger': true, 'is-active': !_vm.showBurger
    },
    on: {
      "click": function($event) {
        _vm.$emit('toggleSidebar')
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('span', {
    staticClass: "navbar-item"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Log out")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
}]}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-4 has-text-centered"
  }, [_vm._v("Please, authorize")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": _vm.clearError
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-medium': true, 'is-danger': _vm.veeErrors.has('username')
    },
    attrs: {
      "name": "username",
      "type": "email",
      "placeholder": "Enter your email"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('username')),
      expression: "veeErrors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('username')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-medium': true, 'is-danger': _vm.veeErrors.has('password')
    },
    attrs: {
      "name": "password",
      "placeholder": "Enter your password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('password')),
      expression: "veeErrors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('password')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.error) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-grouped-centered"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-dark",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container has-text-centered has-text-grey"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v(_vm._s(_vm.year) + " ©")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("Fusion Console by "), _c('a', {
    attrs: {
      "href": "https://fusionnextinc.com/"
    }
  }, [_vm._v("Fusion Next Inc.")])])
}]}

/***/ })
]),[214]);


// WEBPACK FOOTER //
// static/js/app.dfff846e8701179aa75f.js